import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Typography } from '@mui/material';
import { format } from 'date-fns';
import { FC } from 'react';

import {
  CustomerTableBox,
  MenuIconBox,
  OrderCardItem,
  OrderIdBox,
  TableBox,
  TimeBox,
  TimeTableBox,
} from 'containers/POSPage/PosTableCard/index.styled';
import { getOrderSum, getTotalOrderItems } from 'containers/POSPage/PosTableCard/utils';

import { FULL_DATE_FORMAT } from 'constants/general';
import { POSQueue } from 'types/pos.interface';
import { formatUserName } from 'utils/formatters';

interface OrderCardRowProps {
  row: POSQueue;
  onCustomerHover?: () => void;
  handleOrderClick: (orderId: string) => void;
}

const OrderCardRow:FC<OrderCardRowProps> = ({ row, onCustomerHover, handleOrderClick }) => (
  <OrderCardItem>
    <CustomerTableBox onMouseOver={onCustomerHover}>
      <Typography variant="body3">{formatUserName(row.firstName, row.lastName)}</Typography>
      <Typography variant="body3">{row.dateOfBirth}</Typography>
      <Typography variant="body3">{`Patient #${row.patientNumber ?? ''}`}</Typography>
    </CustomerTableBox>

    <TableBox pt={0.5}>
      {row.orders?.map((order) => (
        <OrderIdBox key={order.id} onClick={() => handleOrderClick(order.id.toString())}>
          <Typography variant="body3">{order.id}</Typography>
        </OrderIdBox>
      ))}
    </TableBox>

    <TableBox>
      <Typography mt={0.5} ml={0.5} variant="body3">
        Retail
      </Typography>
    </TableBox>

    <TableBox>
      <Typography mt={0.5} variant="body3">
        {`${getTotalOrderItems(row.orders ?? [])} items`}
      </Typography>
      <Typography variant="body3">{`$${getOrderSum(row.orders ?? [])}`}</Typography>
    </TableBox>

    <TimeTableBox>
      <TimeBox>
        <Typography variant="body3">{format(new Date(row.timeIn), FULL_DATE_FORMAT)}</Typography>
      </TimeBox>
      <MenuIconBox>
        <MoreVertIcon />
      </MenuIconBox>
    </TimeTableBox>
  </OrderCardItem>
);

export default OrderCardRow;
